import { DateUtils } from "../PA.Core/Basic/Dates";
import * as _ from "lodash"
import { ISettingsInputs, ISettingsInputSpec } from "./PA.UIM.Core.IF.Settings";
import { NumberUtils } from "../PA.Core/Basic/Numbers";

export class SettingsUtils {


    static coerceValue(val: any, sType: "string" | "number" | "date" | string, dflt: any): any {
        switch(sType) {
            case "string":
                if(_.isString(val))
                    return val
                if(_.isNumber(val))
                    return '' + val
                return dflt

            case "number":
                if(_.isNumber(val))
                    return val
                if(_.isNumber(+val))
                    return +val
                return dflt

            case "date":
                if(_.isDate(val))
                    return val

                if(_.isString(val)) {
                    let dt = DateUtils.convertFromSAPBW(val)
                    if(_.isDate(dt))
                        return dt
                    // Check if ISO format
                    dt = new Date(val)
                    if(_.isDate(dt))
                        return dt
                }

                return dflt

            default:

                return dflt
        }
    }

    static getDescription(spec: ISettingsInputSpec, vals: ISettingsInputs): string {
        let rv: string[] = []
        let dctVals = _.keyBy(vals?.inputs || [], (i) => i.settingId)
        _.forEach(spec?.settings, (s) => {
            if(_.isEmpty(s))
                return
            let name = s.name
            let inputVal = dctVals[s.id]?.value
            let inputValScrub = SettingsUtils.coerceValue(inputVal, s.type, undefined)
            switch(s.type){
                case "string":
                    rv.push(`${name}: ${inputValScrub || ''}`)
                    break

                case "number":
                    if (s.percent) {
                        if (_.isNumber(inputValScrub))
                            rv.push(`${name}: ${NumberUtils.formatPercent(inputValScrub) || ''}`)
                        else
                            rv.push(`${name}: -`)
                    } else {
                        if (_.isNumber(inputValScrub))
                            rv.push(`${name}: ${NumberUtils.round(inputValScrub, s.decimalPlaces || 0) || ''}`)
                        else
                            rv.push(`${name}: -`)
                    }

                    break

                case "date":
                    if (_.isDate(inputValScrub))
                        rv.push(`${name}: ${DateUtils.formatDate(inputValScrub) || ''}`)
                    else
                        rv.push(`${name}: -`)
                    break
            }
        })

        return rv.join(", ")
    }
}